// Generated file : do not modify
export enum DashboardWidgetWidgetTypes
{
  NONE = 0,
  KPI,
  BAR,
  DOUGHNUT,
  MULTITAB
};

import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Dashboard Widget
export class WidgetMeta {
  // Row
  public row: number;
  // Column
  public col: number;
  // rowSpan
  public rowSpan: number;
  // colSpan
  public colSpan: number;
  // order
  public order: number;
  // empty Text
  public emptyText: string;
  // tabs
  public tabs: unknown[];
  // chart Options
  public chartOptions: unknown;
  // button Label
  public buttonLabel: string;
  // dropdown options
  public dropdownOptions: string[];
  // selected Options
  public selectedOption: string;

  constructor() {
    this.row = 0;
    this.col = 0;
    this.rowSpan = 0;
    this.colSpan = 0;
    this.order = 0;
    this.emptyText = '';
    this.tabs = [];
    this.chartOptions = null;
    this.buttonLabel = '';
    this.dropdownOptions = [];
    this.selectedOption = '';
  }
}

export class WidgetInfo {
  // indice
  public id: number;
  // label clicked
  public label: string;
  // filtre sélectionné
  public selected: string;
  // tabulation sélectionnés
  public tab: string;

  constructor() {
    this.id = 0;
    this.label = '';
    this.selected = '';
    this.tab = '';
  }
}

export class WidgetData {
  // indice
  public id: number;
  // Widget Data
  public data: unknown;

  constructor() {
    this.id = 0;
    this.data = null;
  }
}

export default class DashboardWidget  {
  // indice
  public id: number;
  // Title
  public title: string;
  // Widget Type
  public widgetType: DashboardWidgetWidgetTypes;
  // Widget Data
  public data: unknown;
  // Widget Meta
  public widgetMeta: WidgetMeta;

  constructor() {
    this.id = 0;
    this.title = '';
    this.widgetType = DashboardWidgetWidgetTypes.NONE;
    this.data = null;
    this.widgetMeta = new WidgetMeta();
  }

  public static fromJson (obj: DashboardWidget): DashboardWidget {
    const newDashboardWidget: DashboardWidget = new DashboardWidget();
    newDashboardWidget.id = obj.id;
    newDashboardWidget.title = obj.title;
    newDashboardWidget.widgetType = obj.widgetType;
    newDashboardWidget.data = obj.data;
    newDashboardWidget.widgetMeta = JSON.parse(JSON.stringify(obj.widgetMeta));
    return newDashboardWidget;
  }

  public toJsonDashboardWidget (): string {
    const json = {
      id: this.id,
      title: this.title,
      widgetType: this.widgetType,
      data: this.data,
      widgetMeta: this.widgetMeta,
    }
    return JSON.stringify(json);
  }

  public fromDashboardWidget (obj: DashboardWidget): void {
    this.id = obj.id;
    this.title = obj.title;
    this.widgetType = obj.widgetType;
    this.data = obj.data;
    this.widgetMeta = obj.widgetMeta;
  }

  public compareDashboardWidget (value: DashboardWidget): boolean {
    return (this.toJsonDashboardWidget() == value.toJsonDashboardWidget());
  }

  public cloneDashboardWidget (): DashboardWidget {
    return DashboardWidget.fromJson(this);
  }

  public static load (): Promise<DashboardWidget[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/dashboardwidgets/load', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: DashboardWidget[] = [];
              res.data.forEach(( a: DashboardWidget ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static action (data: WidgetInfo): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/dashboardwidgets/action', data, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static select (data: WidgetInfo): Promise<WidgetData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/dashboardwidgets/select', data, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(dashboardWidgets: DashboardWidget[]) {
  }
}
